import { vaultPostRequest } from '../helpers';
import type { IReframeClipRequest } from './reframe-clip-request';
import type { IReframeClipResponse } from './reframe-clip-response';
import { reframeClipResponseSchema } from './reframe-clip-response';

export async function reframeClipApi(body: IReframeClipRequest): Promise<IReframeClipResponse> {
  return vaultPostRequest({ path: '/reframe', body, schema: reframeClipResponseSchema });
}
